import { gql } from '@apollo/client'

export const DELETE_PICOS_POI = gql`
  mutation DeletePicOSPOI($input: ID!) {
    deletePicosPoi(poiId: $input) {
      deleted
    }
  }
`
